import KeenSlider from "keen-slider";
import {currentLayout} from "src/utils/base";

class StyleCarousel {
  constructor() {
    this.bindClickEventsToAnalytics = this.bindClickEventsToAnalytics.bind(
      this
    );
    this.handleSlideChange = this.handleSlideChange.bind(this);
    this.handleNavCellClick = this.handleNavCellClick.bind(this);
    this.trackInAnalytics = this.trackInAnalytics.bind(this);

    if (!$(".pc-Style-hero-imageCarousel").length) {
      return;
    }
    $(document).on("swatchselect.style.colorinteraction", (e, data) => {
      if (this.KeenSlider != null) {
        this.KeenSlider.moveToSlide(0);
      }
    });
    $(document).on("hero.carousel.change", this.handleSlideChange);
    $(document).on(
      "click",
      ".pc-Style-hero-navCarousel-cell",
      this.handleNavCellClick
    );

    this.setUpCarousel();
    this.bindClickEventsToAnalytics();
  }

  // private

  bindClickEventsToAnalytics() {
    $(document).on(
      "click",
      ".pc-Style-hero-image .keen-slider-prev-next-button",
      () => {
        return this.trackInAnalytics("carousel");
      }
    );
    $(document).on("click", ".pc-Style-hero-navCarousel-cell", () => {
      return this.trackInAnalytics("box");
    });
    return $(document).on(
      "click",
      ".pc-Style-hero-image .keen-slider-dots .dot",
      () => {
        return this.trackInAnalytics("dot");
      }
    );
  }

  setUpCarousel() {
    this.KeenSlider = new KeenSlider("#pc-Style-hero-imageCarousel", {
      loop: true,
      slides: ".pc-Style-hero-imageCarousel-cell",
      created: function (instance) {
        $(".pc-Style-hero-imageCarousel-cell").css({display: "flex"});
        document
          .getElementById("arrow-left")
          .addEventListener("click", function () {
            instance.prev();
          });

        document
          .getElementById("arrow-right")
          .addEventListener("click", function () {
            instance.next();
          });

        var dots_wrapper = document.getElementById("dots");
        var slides = document.querySelectorAll(
          ".pc-Style-hero-imageCarousel-cell"
        );
        slides.forEach(function (t, idx) {
          var dot = document.createElement("button");
          dot.classList.add("dot");
          if (idx === 0) {
            dot.classList.add("dot--active");
          }
          dots_wrapper.appendChild(dot);
          dot.addEventListener("click", function () {
            instance.moveToSlide(idx);
          });
        });
      },
      slideChanged(instance) {
        const slide = instance.details().relativeSlide;
        $(document).trigger("hero.carousel.change", {
          slideNo: slide
        });
        const dots = document.querySelectorAll(".dot");
        dots.forEach(({classList}, idx) => {
          idx === slide
            ? classList.add("dot--active")
            : classList.remove("dot--active");
        });
      }
    });

    // Nav slider is only needed for md & above
    if (currentLayout() != "sm") {
      const totalNavCells = document.querySelectorAll(
        ".pc-Style-hero-navCarousel-cell"
      ).length;

      // Each cell is 60px wide + 10px for spacing between cells
      const navCarouselWidth = totalNavCells * 70;
      if ($(".pc-Style-hero-navCarousel").width() > navCarouselWidth) {
        $(".pc-Style-hero-navCarousel").width(navCarouselWidth);
      }
      // Each cell is 60px wide + 10px for spacing between cells
      const maxpossibleCells = Math.floor(
        $(".pc-Style-hero-navCarousel").width() / 70
      );
      this.KeenSliderNav = new KeenSlider("#pc-Style-hero-navCarousel", {
        centered: maxpossibleCells < totalNavCells,
        loop: maxpossibleCells < totalNavCells,
        mode: "free",
        slides: ".pc-Style-hero-navCarousel-cell",
        slidesPerView:
          maxpossibleCells < totalNavCells ? maxpossibleCells : totalNavCells,
        created: function (instance) {
          const slides = document.querySelectorAll(
            ".pc-Style-hero-navCarousel-cell"
          );
          slides.forEach(function (slide, idx) {
            if (idx === 0) {
              slide.classList.add("is-selected");
            }
            slide.setAttribute("data-slide-number", idx);
          });
        }
      });
    }
  }

  trackInAnalytics(source) {
    const selectedIndex = this.KeenSlider.details().relativeSlide;
    return CustomInk.Metrics.fireEvent({
      category: "pdp imagery",
      action: `${this.styleId}`,
      label: `${selectedIndex} ${source}`,
      interaction: true
    });
  }

  // Event Handlers

  handleNavCellClick(e) {
    const el = $(e.currentTarget);
    const slideNo = parseInt(el.data("slide-number"), 10);
    this.KeenSlider.moveToSlide(slideNo);
  }

  handleSlideChange(e, data) {
    if (this.KeenSliderNav != null) {
      this.KeenSliderNav.moveToSlide(data.slideNo);
      $(`.pc-Style-hero-navCarousel-cell.is-selected`).removeClass(
        "is-selected"
      );
      $(`.pc-Style-hero-navCarousel-cell:eq(${data.slideNo})`).addClass(
        "is-selected"
      );
    }
  }
}

jQuery(() => (ProductCatalog.StyleCarousel = new StyleCarousel()));
